// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPreparation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.4686L2.37571 10.0928C2.13296 9.44101 2.00029 8.73559 2.00029 7.99918C2.00029 4.68557 4.6865 1.99936 8.00011 1.99936C8.73652 1.99936 9.44194 2.13203 10.0938 2.37478L12.4686 0L13.8827 1.41417L11.877 3.41994C12.1315 3.63569 12.3679 3.87229 12.5834 4.12711L14.5885 2.12199L15.9895 3.53616L13.6269 5.91193C13.8681 6.56198 13.9999 7.26519 13.9999 7.99918C13.9999 11.3128 11.3137 13.999 8.00011 13.999C7.26612 13.999 6.56291 13.8672 5.91286 13.626L3.53541 15.9895L2.12124 14.5892L4.12804 12.5825C3.87322 12.367 3.63662 12.1306 3.42087 11.876L1.41417 13.8827L0 12.4686ZM7.56335 11.9755C7.70679 11.9911 7.85252 11.9991 8.00011 11.9991C10.2092 11.9991 12 10.2082 12 7.99918C12 7.85159 11.992 7.70586 11.9764 7.56242L7.56335 11.9755ZM11.1617 5.54875L5.54968 11.1608C5.28553 10.9558 5.04776 10.7184 4.84233 10.4546L10.4555 4.8414C10.7193 5.04683 10.9567 5.2846 11.1617 5.54875ZM4.02467 8.44388L8.44481 4.02374C8.2988 4.00759 8.15042 3.9993 8.00011 3.9993C5.79104 3.9993 4.00023 5.79011 4.00023 7.99918C4.00023 8.14949 4.00852 8.29787 4.02467 8.44388Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPreparation is a generated icon component.
 */
let IconMedPreparation = IconMedPreparation_1 = class IconMedPreparation extends IconBaseElement {
    render() {
        return html `${IconMedPreparation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPreparation.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedPreparation = IconMedPreparation_1 = __decorate([
    customElement('zui-icon-med-preparation')
], IconMedPreparation);
export { IconMedPreparation };
